import React from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"

import Routes from "@/routes"
import CruiseLineOnly from "@/auth_descriptor/CruiseLineOnly"

// Each report is an HTML grid, opened in a new tab so the allocation page keeps
// its state. Grouped under headers as the DataExchange exports menu
// (Navigation::NestedDropdownComponent) groups its exports.
const openReport = (path: string) => () => {
  window.open(path, "_blank")?.focus()
}

const ReportsDropdown = () => (
  <DropdownButton title="Reports" variant="secondary">
    <Dropdown.Header>Departures</Dropdown.Header>
    <Dropdown.Item onClick={openReport(Routes.off_schedule_inventories_path())}>
      Off-Schedule Departures
    </Dropdown.Item>
    <CruiseLineOnly>
      <Dropdown.Item
        onClick={openReport(Routes.data_exchange_exports_inventory_departure_allocations_path())}
      >
        Departure Allocations
      </Dropdown.Item>
      <Dropdown.Item
        onClick={openReport(Routes.data_exchange_exports_inventory_departure_changes_path())}
      >
        Departure Changes
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Header>Sales</Dropdown.Header>
      <Dropdown.Item onClick={openReport(Routes.onboarding_mismatched_sales_inventories_path())}>
        Mismatched Sales
      </Dropdown.Item>
    </CruiseLineOnly>
  </DropdownButton>
)

export default ReportsDropdown
